import { useParams, useNavigate } from 'react-router-dom'
import Empty from '@/components/ui/Empty/Empty'

interface WorkspaceNotFoundPageProps {
    // What was being opened, for the message. Defaults to a generic wording.
    entity?: 'task' | 'project'
}

// Shown (SCD-934, scenario 7) when a signed-in user opens a deep link to a task/project that
// doesn't exist (or was deleted). A clear "not found" with an explicit way out — not a silent
// bounce to the dashboard, and distinct from the no-access screen.
const WorkspaceNotFoundPage = ({ entity }: WorkspaceNotFoundPageProps) => {
    const navigate = useNavigate()
    const { workspace } = useParams<{ workspace: string }>()

    const noun = entity ?? 'page'
    const text = `This ${noun} doesn't exist or was deleted.`
    const projectsPath = workspace ? `/${workspace}/projects` : '/'

    return (
        <Empty
            title="Not found"
            text={text}
            buttonTitle="Go to projects"
            onClick={() => navigate(projectsPath, { replace: true })}
            testId="workspace-not-found"
            contained
        />
    )
}

export default WorkspaceNotFoundPage
